import { API_PATH } from 'common/constants/services';
import useQuery from 'hook/useQuery';
import { CoachUser } from 'model/Settlements';
import React, { useEffect, useState } from 'react';

export default function useCoachList() {
  const query = useQuery<CoachListModel>(API_PATH.COACHES);
  return {
    data: query.getQuery.data?.data,
    isLoading: query.getQuery.isLoading,
  };
}
interface CoachListModel {
  items: CoachUser[];
  count: number;
}
